import { useEffect, useRef, useState } from 'react';
import { api, setAuth } from './api';
import { toast } from './feedback';

const GOOGLE_SCRIPT = 'https://accounts.google.com/gsi/client';

// Tải script Google Identity Services một lần
function loadGoogleScript() {
  if (window.google?.accounts?.id) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${GOOGLE_SCRIPT}"]`);
    const script = existing || document.createElement('script');
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', () => reject(new Error('Không tải được Google Sign-In')));
    if (!existing) {
      script.src = GOOGLE_SCRIPT;
      script.async = true;
      document.head.appendChild(script);
    }
  });
}

// Chữ mặc định (kho chứng nhận); trang Kai truyền bản dịch theo ngôn ngữ đang chọn
const DEFAULT_TEXTS = {
  title: 'Đăng nhập quản trị',
  subtitle: 'Chỉ tài khoản Google được cấp quyền mới vào được trang quản lý.',
  loadingButton: 'Đang tải nút đăng nhập Google...',
  signingIn: 'Đang đăng nhập...',
  invalid: 'Đăng nhập Google không hợp lệ, vui lòng thử lại',
  success: 'Đăng nhập thành công',
};

export default function LoginPage({ onSuccess, texts: customTexts, locale = 'vi' }) {
  const texts = { ...DEFAULT_TEXTS, ...customTexts };
  const buttonRef = useRef(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const handleCredential = async ({ credential }) => {
      setError('');
      setLoading(true);
      try {
        const auth = await api.loginGoogle(credential);
        setAuth(auth);
        toast(texts.success);
        onSuccess(auth.role);
      } catch (e) {
        setError(e.status === 401 ? texts.invalid : e.message);
      } finally {
        setLoading(false);
      }
    };

    (async () => {
      try {
        const { googleClientId } = await api.getAuthConfig();
        if (!googleClientId) throw new Error('Server chưa cấu hình Google Client ID');
        await loadGoogleScript();
        if (cancelled) return;
        window.google.accounts.id.initialize({ client_id: googleClientId, callback: handleCredential });
        window.google.accounts.id.renderButton(buttonRef.current, {
          theme: 'outline',
          size: 'large',
          text: 'signin_with',
          shape: 'pill',
          locale,
        });
        setReady(true);
      } catch (e) {
        if (!cancelled) setError(e.message);
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="narrow">
      <div className="card login-card">
        <h2>{texts.title}</h2>
        <p className="muted">{texts.subtitle}</p>
        <div ref={buttonRef} className="google-button" />
        {!ready && !error && <p className="muted">{texts.loadingButton}</p>}
        {loading && <p className="muted">{texts.signingIn}</p>}
        {error && <p className="error">{error}</p>}
      </div>
    </section>
  );
}
